/*
  Zugo - siralama secici.

  Gorunur kisim kendi dugmemiz; secim gizli `<select>` alanina yazilip
  `change` olayi tetikleniyor. Boylece temanin kendi filtre akisi (adres
  guncelleme, urun listesini yenileme) oldugu gibi calismaya devam eder.
*/
class ZugoSort extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.zugo-sort__toggle');
    this.liste = this.querySelector('.zugo-sort__list');
    this.alan = this.querySelector('[data-gercek-alan]');
    this.secili = this.querySelector('[data-secili]');
    if (!this.toggle || !this.alan) return;

    this.disariTikla = (e) => {
      if (!this.contains(e.target)) this.kapat();
    };

    this.toggle.addEventListener('click', () => (this.hasAttribute('open') ? this.kapat() : this.ac()));
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.kapat();
        this.toggle.focus();
      }
    });

    this.querySelectorAll('.zugo-sort__option').forEach((btn) =>
      btn.addEventListener('click', () => this.sec(btn))
    );

    document.addEventListener('click', this.disariTikla);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.disariTikla);
  }

  ac() {
    this.setAttribute('open', '');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  kapat() {
    this.removeAttribute('open');
    this.toggle.setAttribute('aria-expanded', 'false');
  }

  sec(btn) {
    const deger = btn.dataset.value;
    this.querySelectorAll('.zugo-sort__option').forEach((o) =>
      o.setAttribute('aria-selected', o === btn ? 'true' : 'false')
    );
    if (this.secili) this.secili.textContent = btn.querySelector('span').textContent;

    this.alan.value = deger;
    this.alan.dispatchEvent(new Event('change', { bubbles: true }));
    this.kapat();
  }
}

if (!customElements.get('zugo-sort')) {
  customElements.define('zugo-sort', ZugoSort);
}
